// extracted by mini-css-extract-plugin
export default {"select":"styles_select__DjuqM"};